export default __webpack_public_path__ + "static/media/hit.15acc09d.mp3";